/**
 * Which EMV terminal id should stay selected when the available terminal
 * list (re)loads.
 *
 * Keeps the clerk's current pick when it is still one of the listed
 * terminals, and only falls back to the first terminal otherwise - so a
 * `customPgData` refresh (new object identity, same terminals) does not
 * silently reset an operator's choice mid-transaction.
 */
export function pickTerminal(currentId, terminals) {
  const ids = (terminals ?? []).map((terminal) => terminal.id);
  if (ids.length === 0) {
    return currentId;
  }
  return ids.includes(currentId) ? currentId : ids[0] ?? currentId;
}
